import React from 'react';
import { Category } from '../../types';

interface CategoryTabsProps {
  categories: Category[];
  activeCategory: Category;
  onCategoryChange: (category: Category) => void;
}

export const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-4 py-2 rounded-full whitespace-nowrap transition-colors ${
            activeCategory === category
              ? 'bg-primary text-white'
              : 'bg-white text-gray-700 border border-gray-300 hover:border-primary'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};